import React from 'react';
import HowWeThinkWork from '../components/CareersComponents/HowWeThinkWork';
import OpenRoles from '../components/CareersComponents/OpenRoles';
import OurWorkPhilosophy from '../components/CareersComponents/OurWorkPhilosophy';
import { Helmet } from 'react-helmet-async';

function Careers() {
  return (
    <>
      <Helmet>
        <title>Careers - Cognitva Global Technologies Private Limited</title>
        <meta name="description" content="Explore career opportunities at Cognitva Global Technologies Private Limited. Join us to be part of a team that is transforming enterprise-wide intelligence." />
        <meta name="keywords" content="Cognitva, Careers, Job Opportunities, Work Culture, Join Us, Enterprise Intelligence" />
        <link rel="canonical" href="https://www.cognitva.ai/careers" />
        <meta property="og:title" content="Cognitva Global Technologies Private Limited - Careers" />
        <meta property="og:description" content="Explore career opportunities at Cognitva Global Technologies Private Limited. Join us to be part of a team that is transforming enterprise-wide intelligence." />
        <meta property="og:url" content="https://www.cognitva.ai/careers" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.cognitva.ai/images/cognitva-logo.png" />
        <meta property="og:image:alt" content="Cognitva Logo" />
        <meta property="og:site_name" content="Cognitva Global Technologies Private Limited" />

      </Helmet>
      <div>
        <HowWeThinkWork />
        <OurWorkPhilosophy />
        <OpenRoles />
      </div>
    </>
  );
}

export default Careers; 